<div class="container">
  <h1>{{ isEdit ? 'Edit' : 'Add New' }} Bank</h1>
  
  <mat-card>
    <mat-card-content>
      <form [formGroup]="bankForm" (ngSubmit)="onSubmit()">
        <!-- Bank Information -->
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Bank Name</mat-label>
            <input matInput formControlName="name" required>
            <mat-hint>Enter the bank's name</mat-hint>
            @if (bankForm.get('name')?.hasError('required')) {
              <mat-error>
                Bank name is required
              </mat-error>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Starting Balance</mat-label>
            <input matInput type="text" formControlName="starting_balance" numberFormat>
            <span matPrefix>&nbsp;$&nbsp;</span>
            <mat-hint>Initial balance for this bank account</mat-hint>
          </mat-form-field>
        </div>

        <!-- Line of Credit Section -->
        <div class="form-row">
          <div class="checkbox-field full-width">
            <mat-checkbox formControlName="loc">Create Line of Credit</mat-checkbox>
          </div>
        </div>
        @if (bankForm.get('loc')?.value) {
          <div class="form-row int-rate">
            <mat-form-field appearance="outline">
              <mat-label>Interest Rate (%)</mat-label>
              <input matInput type="number" formControlName="loc_interest_rate" min="0" max="100" step="0.01">
              <mat-hint>The interest rate charged per transaction</mat-hint>
              @if (bankForm.get('loc_interest_rate')?.hasError('required')) {
                <mat-error>
                  Interest rate is required
                </mat-error>
              }
              @if (bankForm.get('loc_interest_rate')?.hasError('min')) {
                <mat-error>
                  Interest rate must be greater than or equal to 0
                </mat-error>
              }
              @if (bankForm.get('loc_interest_rate')?.hasError('max')) {
                <mat-error>
                  Interest rate must be less than or equal to 100
                </mat-error>
              }
            </mat-form-field>
          </div>
        }

        <!-- Form Actions -->
        <div class="button-row">
          <button mat-button type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="!bankForm.valid">
            {{ isEdit ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
